import { QueryClient } from '@tanstack/react-query';

// TODO: This should be in a separate folder, but we should design better how ReactQuery cache will be used
export function configureQueryClient() {
    return new QueryClient({
        defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, refetchOnReconnect: false } },
    });
}
